module.exports = __webpack_public_path__ + "static/media/emj04.56cdbe69.svg";